export function NoItems({ message }: { message: React.ReactNode }) {
  return <div className="p-4 text-center text-dim">{message}</div>;
}
